export default __webpack_public_path__ + "static/port-10-836c835b38998169fca3dfca17db9019.jpeg";